class ProductInformationMobileDescription {
  constructor(section) {
    this.section = section;
    this.media_query = window.matchMedia('(max-width: 749px)');
    this.handle_change = this.handle_change.bind(this);

    this.media_query.addEventListener('change', this.handle_change);
    this.handle_change();
  }

  handle_change() {
    if (this.media_query.matches) {
      this.enable_accordion();
    } else {
      this.disable_accordion();
    }
  }

  enable_accordion() {
    const heading = this.section.querySelector(".product-details [class*='description_heading']");
    const description = this.section.querySelector(".product-details [class*='text_aEtTtq']");

    if (!heading || !description || description.closest('.product-information__description-accordion')) {
      return;
    }

    const summary_text = heading.textContent.trim() || 'Description';
    const accordion = document.createElement('accordion-custom');
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const label = document.createElement('span');
    const icon = document.createElement('span');
    const content = document.createElement('div');

    accordion.className = 'product-information__description-accordion';
    details.className = 'details product-information__description-details';
    summary.className = 'product-information__description-summary';
    label.className = 'product-information__description-label';
    icon.className = 'product-information__description-icon svg-wrapper icon-caret icon-animated';
    content.className = 'product-information__description-content details-content';

    label.textContent = summary_text;
    icon.innerHTML = `
      <svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    summary.append(label, icon);
    content.append(description);
    details.append(summary, content);
    accordion.append(details);

    heading.hidden = true;
    heading.before(accordion);
  }

  disable_accordion() {
    const accordion = this.section.querySelector('.product-information__description-accordion');
    const heading = this.section.querySelector(".product-details [class*='description_heading']");
    const description = accordion?.querySelector("[class*='text_aEtTtq']");

    if (!accordion || !heading || !description) {
      return;
    }

    heading.hidden = false;
    heading.after(description);
    accordion.remove();
  }
}

const setup_product_information_descriptions = (root = document) => {
  const sections = root.querySelectorAll("[data-mobile-description-accordion='true']");

  sections.forEach((section) => {
    if (section.product_information_mobile_description) {
      section.product_information_mobile_description.handle_change();
      return;
    }

    section.product_information_mobile_description = new ProductInformationMobileDescription(section);
  });
};

setup_product_information_descriptions();

document.addEventListener('shopify:section:load', (event) => {
  setup_product_information_descriptions(event.target);
});
